export class QuickviewDataLoader {
  getData(url, sectionId) {
    const fullUrl = new URL(`${window.location.origin}${url}`);
    fullUrl.searchParams.set("section_id", sectionId);
    const urlString = fullUrl.toString();

    if (urlString === this._lastUrl) {
      if (this._data) return Promise.resolve(this._parseData(this._data));
      if (this._loadingData) return this._loadingData;
    }

    this._lastUrl = urlString;
    this._loadingData = fetch(fullUrl)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;
        return this._parseData(data);
      });

    return this._loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    return document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);
  }
}
